import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Router } from '@angular/router';
import { ApiService } from '../../api/api.service';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router, private api:ApiService) {}

    

    canActivate() {
        if (localStorage.getItem('isLoggedin')) {
            return true;
        }

        this.router.navigate(['/login']);
        return false;
    }

    public updateToken(token:string, refresh_token:string)
    {
       localStorage.setItem('_token', token);
       localStorage.setItem('_refreshToken', refresh_token);
    }

    public hasAuthorization():boolean
    {
        var itm=localStorage.getItem('isLoggedin');
        
        if(localStorage.getItem('isLoggedin'))
            return true;

        return false;
    }

    public hasAuthorizationRefresh():boolean
    {
        if(localStorage.getItem('_refreshToken'))
            return true;

        return false;
    }

    public refreshToken()
    {
        return this.api.refreshToken(localStorage.getItem('_refreshToken'));
    }

    public getHeaderAuthorization(newtoken:string):string
    {
        if(newtoken.length==0)
            newtoken = localStorage.getItem('_token');

        return 'Bearer '+newtoken;
    }


    public clearAuthToken()
    {
        localStorage.setItem('_token','');
        localStorage.setItem('isLoggedin','');
    }

    public get hasAccessToClients():boolean
    {              
        return this.hasRole('ROLE_ADMIN')  
        ||this.hasRole('ROLE_CLINIC')
        ||this.hasRole('ROLE_RESEARCHER')
        ||this.hasRole('ROLE_DATA_OPERATOR');
    }

    public get hasAccessToCases():boolean
    {              
        return this.hasRole('ROLE_ADMIN')  
        ||this.hasRole('ROLE_CLINIC')
        ||this.hasRole('ROLE_RESEARCHER')
        ||this.hasRole('ROLE_DATA_OPERATOR');
    }

    public get hasAccessToTherapists():boolean
    {              
        return this.hasRole('ROLE_ADMIN')  
        ||this.hasRole('ROLE_CLINIC');        
    }

    public get hasAccessToSessions():boolean
    {             
        
        return this.hasRole('ROLE_ADMIN')  
        ||this.hasRole('ROLE_THERAPIST')
        ||this.hasRole('ROLE_RESEARCHER')
        ||this.hasRole('ROLE_DATA_OPERATOR');
    }


    hasRole(role_name:string):boolean
    {
        if (!localStorage.getItem('isLoggedin')) {
            return false;
        }

        var roles_list:string = localStorage.getItem('roles');
        
        if(roles_list==undefined 
        || roles_list==null
        || roles_list.length==0) return false;

        var roles:string[] = roles_list.split(',');
        var found:boolean=false;
        
        roles.forEach((val)=>
        {   
            if(role_name.toUpperCase()==val.trim().toUpperCase())
            {
                found=true;
            }
        });
        return found;
    }
}



// WEBPACK FOOTER //
// I:/Yog/Projects/Web/LetterDev/wwwroot/ManagerApp/wwwroot/src/app/shared/guard/auth.guard.ts